<template>
  <div>
    <div class="loading" v-if="loading">
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <ListGalleries></ListGalleries>

  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";

const imageBuilder = imageUrlBuilder(sanity);

const query = `*[_type == "gallery"] {
  _id,
  name,
  galleryLinked,
  galleryLocal
} | order(_createdAt desc)
`;

export default {
  name: "Galleries",
  data() {
    return {
      loading: true,
      gallerys: []
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;
      sanity.fetch(query).then(
        gallerys => {
          this.loading = false;
          this.gallerys = gallerys;
        },
        error => {
          this.error = error;
        }
      );
    }
  }
};
</script>

<style scoped>
.galleries-list {
  display: grid;
  margin: 0;
  padding: 36px;
  grid-gap: 36px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-auto-flow: dense;
}
.galleries-list li {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.galleries-list li a {
  width: 100%;
  display: block;
  text-decoration: none;
}
.gallery__name {
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--color-mono-0);
    text-decoration: none;
}
.gallery__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gallery__thumbnail {
  position: relative;
  display: block;
  padding-bottom: 125%;
  background-position: center top;
  background-size: cover;
  background-color: var(--color-mono-5);
  background-repeat: no-repeat;
	width: 100%;
  border-radius: 5px;
  overflow: hidden;
}
.gallery__count {
  font-size: 0.825rem;
  font-weight: 400;
  color: var(--color-mono-0);
  text-decoration: none;
}
.gallery__title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
}
</style>
